"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _ArrowLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLeft24"));
var _reactDom = require("react-dom");
var _framerMotion = require("framer-motion");
var _HBModalCloseButton = _interopRequireDefault(require("./HBModalCloseButton"));
var _useIPhoneSafariStatusBarColor = _interopRequireDefault(require("../common/useIPhoneSafariStatusBarColor"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _HBModal = require("./HBModal.styles");
var _HBCheckbox = _interopRequireDefault(require("../HBCheckbox/HBCheckbox"));
var _shared = require("../../utils/shared.utils");
var _useWindowSize2 = require("../common/useWindowSize");
var _HBTourTooltip = require("../HBTour/HBTourTooltip.styles");
var _useScrollToElementEffect = _interopRequireDefault(require("../common/useScrollToElementEffect"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _excluded = ["customButton", "scope", "size", "testIdName", "tooltipContent", "tooltipProps", "type", "loading"]; // import useBodyScrollLock from '../common/useBodyScrollLock';
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CHILD_MODAL_STYLES = {
  modal: {
    boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.2)'
  },
  container: {
    backgroundColor: 'unset'
  }
};
function HeaderActionButton(_ref) {
  var headerAction = _ref.headerAction,
    alignment = _ref.alignment;
  var onClick = headerAction.onClick,
    icon = headerAction.icon,
    text = headerAction.text;
  return /*#__PURE__*/_react["default"].createElement(_HBModal.HeaderButton, {
    onClick: onClick,
    $alignment: alignment
  }, icon, /*#__PURE__*/_react["default"].createElement(_HBModal.StyledHeaderButtonText, {
    type: "Subtitle2DarkSecondary",
    transform: "uppercase",
    "data-testidtype": "hb-modal-header-action--button"
  }, text));
}
function ActionButton(_ref2) {
  var action = _ref2.action,
    isMediumUp = _ref2.isMediumUp,
    isSubmitting = _ref2.isSubmitting;
  var customButton = action.customButton,
    _action$scope = action.scope,
    scope = _action$scope === void 0 ? 'system' : _action$scope,
    _action$size = action.size,
    size = _action$size === void 0 ? 'sm' : _action$size,
    testIdName = action.testIdName,
    tooltipContent = action.tooltipContent,
    tooltipProps = action.tooltipProps,
    type = action.type,
    loading = action.loading,
    actionProps = (0, _objectWithoutProperties2["default"])(action, _excluded);
  var ButtonComponent = customButton || _HBButton["default"];
  var buttonTheme = customButton ? 'custom' : action.theme;
  return /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], (0, _extends2["default"])({
    disabled: !tooltipContent,
    target: /*#__PURE__*/_react["default"].createElement(_HBModal.ActionSpacer, {
      $isMediumUp: isMediumUp
    }, /*#__PURE__*/_react["default"].createElement(ButtonComponent, (0, _extends2["default"])({
      size: size,
      scope: scope,
      fullWidth: true,
      buttonTheme: buttonTheme,
      testId: testIdName ? "hb-modal-".concat(testIdName, "--button") : undefined,
      testIdType: "hb-modal-action--button",
      type: type,
      loading: loading || type === 'submit' && isSubmitting
    }, actionProps), action.text))
  }, tooltipProps), tooltipContent);
}
var HBModal = function HBModal(_ref3) {
  var actions = _ref3.actions,
    _ref3$actionsAlignmen = _ref3.actionsAlignment,
    actionsAlignment = _ref3$actionsAlignmen === void 0 ? 'right' : _ref3$actionsAlignmen,
    actionsContainerStyles = _ref3.actionsContainerStyles,
    actionsStyles = _ref3.actionsStyles,
    bodyStyles = _ref3.bodyStyles,
    checkbox = _ref3.checkbox,
    children = _ref3.children,
    className = _ref3.className,
    closeButtonText = _ref3.closeButtonText,
    closeButtonTooltipText = _ref3.closeButtonTooltipText,
    closeIconColor = _ref3.closeIconColor,
    containerStyles = _ref3.containerStyles,
    forceMobile = _ref3.forceMobile,
    hasChildModalOverlay = _ref3.hasChildModalOverlay,
    headerActions = _ref3.headerActions,
    _ref3$headerActionsAl = _ref3.headerActionsAlignment,
    headerActionsAlignment = _ref3$headerActionsAl === void 0 ? 'left' : _ref3$headerActionsAl,
    hideBackdrop = _ref3.hideBackdrop,
    hideCloseButton = _ref3.hideCloseButton,
    _ref3$isAlmostFullScr = _ref3.isAlmostFullScreen,
    isAlmostFullScreen = _ref3$isAlmostFullScr === void 0 ? false : _ref3$isAlmostFullScr,
    isChildModal = _ref3.isChildModal,
    _ref3$isEmptyTitle = _ref3.isEmptyTitle,
    isEmptyTitle = _ref3$isEmptyTitle === void 0 ? false : _ref3$isEmptyTitle,
    _ref3$isFullScreenOnM = _ref3.isFullScreenOnMobile,
    isFullScreenOnMobile = _ref3$isFullScreenOnM === void 0 ? false : _ref3$isFullScreenOnM,
    _ref3$isOpen = _ref3.isOpen,
    isOpen = _ref3$isOpen === void 0 ? false : _ref3$isOpen,
    _ref3$isRequiredPromp = _ref3.isRequiredPrompt,
    isRequiredPrompt = _ref3$isRequiredPromp === void 0 ? false : _ref3$isRequiredPromp,
    _ref3$isWithConfetti = _ref3.isWithConfetti,
    isWithConfetti = _ref3$isWithConfetti === void 0 ? false : _ref3$isWithConfetti,
    _ref3$maxHeight = _ref3.maxHeight,
    maxHeight = _ref3$maxHeight === void 0 ? '90%' : _ref3$maxHeight,
    _ref3$maxWidth = _ref3.maxWidth,
    maxWidth = _ref3$maxWidth === void 0 ? '1075px' : _ref3$maxWidth,
    modalBodyRef = _ref3.modalBodyRef,
    modalCustomAnimation = _ref3.modalCustomAnimation,
    noBackdropAnimationOnOpen = _ref3.noBackdropAnimationOnOpen,
    _ref3$noInnerScroll = _ref3.noInnerScroll,
    noInnerScroll = _ref3$noInnerScroll === void 0 ? false : _ref3$noInnerScroll,
    onBack = _ref3.onBack,
    onBackdropClick = _ref3.onBackdropClick,
    _onClose = _ref3.onClose,
    _onModalFadeOutComplete = _ref3.onModalFadeOutComplete,
    submitForm = _ref3.submitForm,
    resetForm = _ref3.resetForm,
    isSubmitting = _ref3.isSubmitting,
    onScroll = _ref3.onScroll,
    parent = _ref3.parent,
    scrollToRef = _ref3.scrollToRef,
    _ref3$testId = _ref3.testId,
    testId = _ref3$testId === void 0 ? 'hb-modal' : _ref3$testId,
    _ref3$title = _ref3.title,
    title = _ref3$title === void 0 ? null : _ref3$title,
    _ref3$titleAlignment = _ref3.titleAlignment,
    titleAlignment = _ref3$titleAlignment === void 0 ? 'center' : _ref3$titleAlignment,
    footerExtraContent = _ref3.footerExtraContent,
    backdropId = _ref3.backdropId,
    inert = _ref3.inert,
    blurBackdrop = _ref3.blurBackdrop,
    theme = _ref3.theme;
  var modalRef = (0, _react.useRef)(null);
  var _modalBodyRef = (0, _react.useRef)(null);
  var __modalBodyRef = modalBodyRef || _modalBodyRef;
  var isModalFocused = (0, _react.useRef)(false);
  var hasParent = parent != null;
  var shouldAddTitleSection = !!title || isEmptyTitle;
  var hasActions = !!actions || !!checkbox;
  var isAiModal = theme === 'ai';
  var handleBackdropClick = function handleBackdropClick(e) {
    e.stopPropagation(); // Handling modal over modal situation
    if (!isSubmitting && !modalRef.current.contains(e.target) && !isRequiredPrompt && !isModalFocused.current // handling situation where the cursor leaves the modal while marking text
    ) {
      if ((0, _shared.isFunction)(onBackdropClick)) {
        onBackdropClick();
      } else if ((0, _shared.isFunction)(_onClose)) {
        _onClose({
          source: 'backdropClick'
        });
      }
    }
    isModalFocused.current = false;
  };
  var handleKey = (0, _react.useCallback)(function (e) {
    if (!hasChildModalOverlay && isOpen && e.key === 'Escape' && (0, _shared.isFunction)(_onClose)) {
      _onClose({
        source: 'escapeKey'
      });
    }
  }, [hasChildModalOverlay, isOpen, _onClose]);
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isMediumUp = _useWindowSize.isMediumUp;

  // This is a temp variable in order to use isFullScreenOnMobile as a feature toggle.
  // This should be converted to isMediumUp only
  var isMediumUpOrForceDesktop = isMediumUp || !isFullScreenOnMobile;
  (0, _react.useEffect)(function () {
    if (!isRequiredPrompt && (0, _shared.isFunction)(_onClose)) {
      document.addEventListener('keyup', handleKey);
      return function () {
        document.removeEventListener('keyup', handleKey);
      };
    }
  }, [isRequiredPrompt, _onClose, handleKey]);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isConfettiRecycle = _useState2[0],
    setIsConfettiRecycle = _useState2[1];

  // eslint-disable-next-line consistent-return
  (0, _react.useEffect)(function () {
    if (isOpen && isWithConfetti) {
      var timeout = setTimeout(function () {
        setIsConfettiRecycle(false);
      }, 10000);
      return function () {
        clearTimeout(timeout);
        setIsConfettiRecycle(true);
      };
    }
  }, [isOpen, isWithConfetti]);
  (0, _useIPhoneSafariStatusBarColor["default"])({
    isActive: isOpen && !isFullScreenOnMobile && !isChildModal,
    color: '#4C4C4C' // this is the resulting color when the modal background is on top of a white background
  });
  (0, _useScrollToElementEffect["default"])(scrollToRef, isOpen);
  var backdropAnimation = _objectSpread(_objectSpread({}, _HBModal.MODAL_ANIMATION), {}, {
    initial: !noBackdropAnimationOnOpen && _HBModal.MODAL_ANIMATION.initial
  });
  var mergedContainerStyles = _objectSpread(_objectSpread({}, containerStyles && containerStyles), isChildModal && CHILD_MODAL_STYLES.container);
  var modalStyles = _objectSpread({}, isChildModal && CHILD_MODAL_STYLES.modal);
  var header = /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, shouldAddTitleSection && /*#__PURE__*/_react["default"].createElement(_HBModal.Header, {
    key: "header",
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    },
    $titleAlignment: titleAlignment,
    $isEmptyTitle: isEmptyTitle
  }, /*#__PURE__*/_react["default"].createElement(_HBTourTooltip.TourPixel, {
    "data-tour-id": "modal_title"
  }), headerActions && /*#__PURE__*/_react["default"].createElement(_HBModal.HeaderButtonsContainer, {
    $alignment: headerActionsAlignment
  }, headerActions.map(function (headerAction) {
    return /*#__PURE__*/_react["default"].createElement(HeaderActionButton, {
      alignment: headerActionsAlignment,
      headerAction: headerAction,
      key: headerAction.text || (0, _shared.guid)()
    });
  })), title || ''), !isRequiredPrompt && (0, _shared.isFunction)(_onClose) && !hideCloseButton && /*#__PURE__*/_react["default"].createElement(_HBModalCloseButton["default"], {
    onClose: function onClose() {
      return _onClose({
        source: 'closeButton'
      });
    },
    "data-testid": "hb-modal-close--button",
    closeButtonText: closeButtonText,
    closeButtonTooltipText: closeButtonTooltipText,
    closeIconColor: closeIconColor
  }), (0, _shared.isFunction)(onBack) && /*#__PURE__*/_react["default"].createElement(_HBModal.BackIcon, {
    onClick: onBack,
    "data-testid": "hb-modal-back--button"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowLeft["default"], {
    color: _colors["default"].neutral800
  })));
  var confetti = isWithConfetti && /*#__PURE__*/_react["default"].createElement(_HBModal.StyledConfetti, {
    recycle: isConfettiRecycle
  });
  var body = /*#__PURE__*/_react["default"].createElement(_HBModal.Body, (0, _extends2["default"])({
    ref: __modalBodyRef,
    $hasActions: hasActions,
    $noInnerScroll: noInnerScroll,
    $isAlmostFullScreen: isAlmostFullScreen,
    style: bodyStyles,
    $isEmptyTitle: isEmptyTitle
  }, !noInnerScroll && !!onScroll && {
    onScroll: onScroll
  }), children);
  var checkboxAndActions = hasActions && /*#__PURE__*/_react["default"].createElement(_HBModal.CheckboxAndActions, {
    $hasCheckbox: !!checkbox || !!footerExtraContent,
    $actionsAlignment: actionsAlignment,
    style: actionsContainerStyles,
    $forceMobile: forceMobile
  }, checkbox && /*#__PURE__*/_react["default"].createElement(_HBModal.StyledHBField, {
    id: checkbox.id,
    inline: true,
    width: isMediumUpOrForceDesktop ? '278px' : 'initial',
    marginLeft: "10px",
    marginTop: "12px",
    marginBottom: "0px",
    label: checkbox.label,
    size: "xs",
    placement: "left"
  }, /*#__PURE__*/_react["default"].createElement(_HBCheckbox["default"], {
    key: checkbox.id,
    id: checkbox.id,
    testId: checkbox.id,
    name: checkbox.id,
    checked: checkbox.checked,
    size: "xs",
    onChange: checkbox.onClick
  })), footerExtraContent && /*#__PURE__*/_react["default"].createElement(_HBModal.FooterExtraContent, null, footerExtraContent), /*#__PURE__*/_react["default"].createElement(_HBModal.Actions, {
    style: actionsStyles,
    $isMediumUp: isMediumUpOrForceDesktop
  }, actions.map(function (action, index) {
    return /*#__PURE__*/_react["default"].createElement(ActionButton, {
      key: index,
      action: action,
      isMediumUp: isMediumUpOrForceDesktop,
      isSubmitting: isSubmitting
    });
  })));
  var childModalOverlay = /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, hasChildModalOverlay && /*#__PURE__*/_react["default"].createElement(_HBModal.ChildModalOverlay, _HBModal.MODAL_ANIMATION));
  var modal = /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, /*#__PURE__*/_react["default"].createElement(_HBModal.Modal, (0, _extends2["default"])({
    role: "dialog",
    "aria-modal": true,
    "data-testid": testId,
    ref: modalRef,
    $maxWidth: isMediumUpOrForceDesktop ? maxWidth : 'none',
    $maxHeight: isMediumUpOrForceDesktop ? maxHeight : 'none',
    className: className,
    $noInnerScroll: noInnerScroll,
    $isAlmostFullScreen: isAlmostFullScreen,
    $isMediumUp: !forceMobile && isMediumUpOrForceDesktop,
    $isFullViewport: isFullScreenOnMobile && !forceMobile && !isMediumUp,
    $isAiModal: isAiModal,
    style: modalStyles,
    onMouseDown: function onMouseDown() {
      return isModalFocused.current = true;
    },
    inert: inert || isSubmitting
  }, modalCustomAnimation, submitForm && {
    as: _framerMotion.motion.form,
    noValidate: true,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      submitForm();
    }
  }), childModalOverlay, header, body, checkboxAndActions));
  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, confetti, modal, noInnerScroll && /*#__PURE__*/_react["default"].createElement(_HBModal.PaddingDiv, null));
  var onModalFadeOutComplete = function onModalFadeOutComplete() {
    _onModalFadeOutComplete === null || _onModalFadeOutComplete === void 0 || _onModalFadeOutComplete();
    resetForm === null || resetForm === void 0 || resetForm();
  };
  var wrapper = /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    onExitComplete: onModalFadeOutComplete
  }, isOpen && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hideBackdrop ? /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, _HBModal.MODAL_ANIMATION, content) : /*#__PURE__*/_react["default"].createElement(_HBModal.Container, (0, _extends2["default"])({
    id: backdropId,
    onClick: handleBackdropClick
  }, backdropAnimation, {
    $hasParent: hasParent,
    $forceMobile: forceMobile,
    $noInnerScroll: noInnerScroll,
    style: mergedContainerStyles,
    $blurBackdrop: blurBackdrop,
    $isAiModal: isAiModal
  }), content)));
  var modalContainer = parent || document.body;
  return /*#__PURE__*/(0, _reactDom.createPortal)(wrapper, modalContainer);
};
var _default = exports["default"] = HBModal;
//# sourceMappingURL=HBModal.js.map